










import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Button from './Button.vue';
import { MESSAGE_TYPE } from '../vo/ChatMessageData';
import SockController, { SOCK_ACTIONS } from '../controller/SockController';

@Component({
	components:{
		Button,
	}
})
export default class AskInfo extends Vue {

	public isLoading:boolean = false;

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

	public sendMessage(index:number):void {
		this.isLoading = true;

		let messages = [
			"J'ai besoin du nom de la constellation",
			"J'ai besoin du nom de l'étoile",
			"J'ai besoin des valeurs A et B",
		];
		let data = {
			type:MESSAGE_TYPE.HELP,
			message:messages[index],
			from:this.$store.state.me.id,
		}
		SockController.instance.sendMessage({action:SOCK_ACTIONS.SEND_MESSAGE, includeSelf:true, data});
		
		setTimeout(_=> {
			this.isLoading = false;
		}, 150);
	}

}
